import {observable} from 'mobx';
import {t} from 'shared/core';

class SignatureViewModel {
  @observable id;
  @observable name;
  @observable signatureData;
  @observable annotationType;
  @observable signatureId;
  @observable assignee;
  @observable color;

  constructor({name, signatureData, signatureId, annotationType, assignee, color, id}) {
    this.name = name;
    this.signatureData = signatureData;
    this.annotationType = annotationType;
    this.signatureId = signatureId;
    this.assignee = assignee
    this.color = color;
    this.id = id;
  }

  static fromCompanySignature(companySignature) {
    return new SignatureViewModel({
      name: companySignature.name,
      signatureData: companySignature.signatureData,
      signatureId: companySignature.id,
      annotationType: 'company_signature'
    });
  }

  static employeeSignature(id, assignee, color) {
    return new SignatureViewModel({
      name: 'components.pdf.annotate.toolbar.Signature',
      annotationType: 'employee_signature',
      id,
      assignee,
      color
    });
  }
}

export default SignatureViewModel;
